export default class UserPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        //
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  model
     * @return {mixed}
     */
    view(user, model)
    {
        //
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        //
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  model
     * @return {mixed}
     */
    update(user, model)
    {
        //
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  model
     * @return {mixed}
     */
    restore(user, model)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  model
     * @return {mixed}
     */
    delete(user, model)
    {
        //
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  model
     * @return {mixed}
     */
    forceDelete(user, model)
    {
        //
    }
}
